// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../../node_modules/@rsbuild/core/compiled/css-loader/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../node_modules/@rsbuild/core/compiled/css-loader/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.YSROYzHttAQs8jOxhQN4{flex-direction:column;flex-grow:1;display:flex;position:relative}.oOML8wygeAQ_A2ELrPYH{align-items:center;gap:4px;display:flex}`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"table": `YSROYzHttAQs8jOxhQN4`,
	"headerName": `oOML8wygeAQ_A2ELrPYH`
};
export default ___CSS_LOADER_EXPORT___;
